class ApiConversion {
    constructor(data) {
        /** @type ?String */
        this.id = data?.id ?? null;

        /** @type ?String */
        this.target = data?.target ?? null;

        /** @type ?String */
        this.category = data?.category ?? null;

        /** @type ?Object */
        this.options = data?.options ?? null;

        /** @type Array */
        this.metadata = data?.metadata ?? [];

        /** @type ?Array */
        this.outputTarget = data?.outputTarget ?? [];
    }

    /**
     * Called by JSON.stringify to get a representation as a serializable object
     *
     * @return {Object}
     */
    toJSON() {
        return {
            id: this.id,
            target: this.target,
            category: this.category,
            options: this.options,
            metadata: this.metadata,
            output_target: this.outputTarget,
        };
    }
}

export { ApiConversion };
